import { render, staticRenderFns } from "./colorPicker.vue?vue&type=template&id=3b80dcee&scoped=true&"
import script from "./colorPicker.vue?vue&type=script&lang=js&"
export * from "./colorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b80dcee",
  null
  
)

export default component.exports